<template>
  <div class="modal_wrapper">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body">
            <div>{{ inputMessage }}</div>
            <div style="margin-top: 10px">宛先: {{ userName }}さん</div>
            <textarea
              class="detail_input_field message"
              v-model="sendMessageInput"
            ></textarea>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="closeButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="confirmButton"
              class="finish_button"
              @click="showConfirm"
            />
          </div>
          <div class="modal_window" v-if="showConfirmModal">
            <sendMessageConfirmModalWindow
              :userName="userName"
              :message="sendMessageInput"
              @close="stayClose"
              @ok="sendMessage"
            >
            </sendMessageConfirmModalWindow>
          </div>
          <div class="complete_modal_window" v-if="showCompleteModal">
            <finishModalWindow :question="completeWord" @close="close">
            </finishModalWindow>
          </div>
          <div class="modal_window" v-if="showFailureModal">
            <finishModalWindow :question="failureWord" @close="stayClose">
            </finishModalWindow>
          </div>
          <div class="loading_modal_window" v-if="showloadingModal">
            <loadingModalWindow @close="close"> </loadingModalWindow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sendMessageConfirmModalWindow from './sendMessageConfirmModalWindow.vue'
import finishModalWindow from './finishModalWindow.vue'
import loadingModalWindow from './loadingModalWindow.vue'
export default {
  props: ['userId', 'userName', 'deviceId'],
  data() {
    return {
      title: 'メッセージ送信',
      inputMessage: '送信するメッセージを入力してください。',
      sendMessageInput: '',
      closeButton: 'キャンセル',
      confirmButton: 'OK',
      completeWord: '',
      showConfirmModal: false,
      showCompleteModal: false,
      showFailureModal: false,
      showloadingModal: false
    }
  },
  components: {
    sendMessageConfirmModalWindow,
    finishModalWindow,
    loadingModalWindow
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    stayClose() {
      this.showConfirmModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
      this.showloadingModal = false
    },
    showConfirm() {
      if (this.sendMessageInput === '') {
        this.failureWord =
          this.errorMsg.MSGCRC0318.name + this.errorMsg.MSGCRC0318.value
        this.showFailureModal = true
      } else {
        this.showConfirmModal = true
      }
    },
    async sendMessage() {
      this.showloadingModal = true
      this.showConfirmModal = false
      try {
        await this.$store.dispatch('loginUsers/sendMessage', {
          userId: this.userId,
          deviceId: this.deviceId,
          message: '(' + this.sendMessageInput + ')'
        })
        this.completeWord = '送信しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_600004
        let eventType = 3
        let reason = 'MSGCRC0141'
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0317') {
            this.failureWord =
              this.errorMsg.MSGCRC0317.name +
              this.errorMsg.MSGCRC0317.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0318') {
            this.failureWord =
              this.errorMsg.MSGCRC0318.name +
              this.errorMsg.MSGCRC0318.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0319.name +
              this.errorMsg.MSGCRC0319.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.modal_container {
  height: 385px;
  width: 635px;
}
.modal_body {
  height: 337px;
}
.body {
  width: 100%;
  height: 229px;
  padding-top: 40px;
  /* IEでスクロールバーを隠す */
  -ms-overflow-style: none;
}
.modal_header {
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.disabled {
  background-color: #afafaf;
}
.message {
  margin-top: 10px;
  min-height: 150px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/sendMessageModalWindow.vue